<template>
  <div class="app-ad-config-management">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <strong>App广告位管理</strong>
      </div>
      <div class="toolbar">
        <span>选择 App：</span>
        <el-select v-model="appId" filterable placeholder="请选择 App" :disabled="saving || appsLoading" @change="loadConfigs">
          <el-option v-for="app in apps" :key="app.id" :value="app.id"
            :label="(app.name || '未命名') + '（' + (app.packageName || '未配置包名') + '）'" />
        </el-select>
        <el-button :disabled="!appId || saving" @click="loadConfigs">重新加载</el-button>
      </div>
      <el-alert title="当前配置仅对所选 App 生效；留空表示未配置，请勿填写其他 App 的广告位。"
        type="info" :closable="false" show-icon />
      <el-alert v-if="error" :title="error" type="error" :closable="false" class="error" />
      <el-empty v-if="!appId" description="请先选择 App；暂无 App 时请到信息管理中创建" />
      <div v-else class="config-panel">
        <div class="form-toolbar">
          <el-button type="primary" size="small" :loading="saving"
            :disabled="loading || !!error || !configs.length" @click="saveConfigs">保存当前 App 配置</el-button>
        </div>
        <el-form v-loading="loading" label-width="210px" class="config-form">
          <el-form-item v-for="item in configs" :key="item.configKey" :label="item.description">
            <el-input v-model.trim="item.configValue" :disabled="saving" maxlength="255"
              :type="['app_key', 'callbackKey'].includes(item.configKey) ? 'password' : 'text'"
              :show-password="['app_key', 'callbackKey'].includes(item.configKey)" :placeholder="'请输入' + item.description" />
            <div class="config-key">{{ item.configKey }}</div>
            <div v-if="item.configKey === 'callbackKey'" class="config-key">仅服务端校验激励回调使用，不会下发安卓；请填写当前 App 对应的回调密钥。</div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { get, put } from '@/utils/http'

export default {
  name: 'AppAdConfigManagement',
  data() {
    return { apps: [], appId: null, configs: [], loading: false, saving: false, appsLoading: false, error: '', requestVersion: 0 }
  },
  async mounted() {
    this.appsLoading = true
    try {
      const result = await get('/admin/app/list')
      this.apps = Array.isArray(result.data) ? result.data : []
    } catch (e) {
      this.error = e.message || 'App列表加载失败'
    } finally {
      this.appsLoading = false
    }
  },
  methods: {
    async loadConfigs() {
      // 切换时立即清空旧表单；版本号防止快速切换后旧响应覆盖新 App。
      const version = ++this.requestVersion
      this.configs = []
      this.error = ''
      if (!this.appId) return
      this.loading = true
      try {
        const result = await get(`/admin/app/${this.appId}/ad-config`)
        if (version !== this.requestVersion) return
        if (result.code !== 200 && result.code !== 1) throw new Error(result.msg || '广告配置加载失败')
        this.configs = Array.isArray(result.data) ? result.data : []
      } catch (e) {
        if (version === this.requestVersion) this.error = e.message || '广告配置加载失败'
      } finally {
        if (version === this.requestVersion) this.loading = false
      }
    },
    async saveConfigs() {
      if (!this.appId || this.loading || this.saving || this.error) return
      // 保存期间锁定 App 选择，URL 和表单始终属于同一个 App。
      this.saving = true
      try {
        const result = await put(`/admin/app/${this.appId}/ad-config`, {
          configs: this.configs.map(item => ({ configKey: item.configKey, configValue: item.configValue || '' }))
        })
        if (result.code !== 200 && result.code !== 1) throw new Error(result.msg || '保存失败')
        this.$message.success('当前App广告配置已保存')
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.app-ad-config-management { padding: 20px; }
.card-header { display: flex; align-items: center; justify-content: space-between; }
.toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 20px; }
.toolbar .el-select { width: 420px; max-width: 60%; }
.config-panel { margin-top: 16px; max-width: 850px; }
.form-toolbar { display: flex; justify-content: flex-end; margin-bottom: 8px; }
.config-form { margin-top: 0; }
.config-key { color: #909399; font-size: 12px; line-height: 20px; }
.error { margin-top: 16px; }
</style>
